import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { paths } from "@libs/paths";
import styles from "./terms.module.css";
import type { NextPage } from "next";

const startsAtText = "2024年1月10日";

const PointTermsPage: NextPage = () => {
  return (
    <CommonLayout noHeaderButton noModal hasFooter>
      <CommonHead title={"ポイント利用規約"} ogUrl={paths.pointTerms} />
      <div className={styles.terms}>
        <main className={styles.main}>
          <div className={styles.inner}>
            <div className={styles.termsTitle}>
              <h1>Fanstaポイント利用規約</h1>
            </div>
            <p className={styles.termsDate}>{startsAtText}&emsp;制定</p>
            <ul>
              <li className={styles.listItem}>
                <div className={styles.detailText}>
                  <p>
                    &emsp;Fanstaポイントとは株式会社MIXI（以下「弊社」といいます）が運営するスポーツ観戦施設（飲食店を含みますがそれに限られません。以下同じ。）情報掲載サービスおよびそれに付随するサービス「Fansta」（以下「本サービス」といいます）のユーザーに付与されるもので、特典と交換することができる弊社が発行するポイントです。Fanstaポイントに関するサービスについてはFanstaポイント利用規約（以下「本規約」といいます）に同意の上ご利用ください。本規約とその他の利用規約等の内容が矛盾する場合には、Fanstaポイント（以下「Fanstaポイント」または「ポイント」といいます）に関しては本規約が優先して適用されるものとします。
                  </p>
                  <p>
                    &emsp;弊社は、本サービスにおける掲載または個別の電子メールによる送信その他適切な方法によって、変更内容および変更の時期を周知することにより、本規約を変更することができます。変更後の本規約は、弊社が別途定める場合を除いて、本サービス上に表示した後に初めてユーザーがポイントに関するサービスを利用した時点より効力を生じるものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  1.&emsp;Fanstaポイントの取得
                </h2>
                <div className={styles.detailText}>
                  <p>
                    (1)&emsp;本サービスに登録しているユーザーは、弊社が別途定める一定の条件を満たすことでポイントを取得することができます。なお、取得できるポイント数は、条件や抽選などで変動します。
                  </p>
                  <p>
                    (2)&emsp;取得日またはポイントを最後に使用した日より180日経過するとポイントは自動的に消滅するものとします。
                  </p>
                  <p>
                    (3)&emsp;本サービスのアカウントを削除すると残っているポイントは消滅します。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  2.&emsp;Fanstaポイントの使用
                </h2>
                <div className={styles.detailText}>
                  <p>
                    (1)&emsp;Fanstaポイントは弊社所定の方法で特典と交換することができます。交換できる特典はユーザーによって異なる場合があります。
                  </p>
                  <p>
                    (2)&emsp;交換する特典に必要なポイント数はそれぞれ別に定めるものとします。なお、特典は、弊社の任意の理由でいつでも変更、終了できるものとします。
                  </p>
                  <p>
                    (3)&emsp;ポイントの使用・取得状況は、本サービス内で確認することができます。
                  </p>
                  <p>
                    (4)&emsp;Fanstaポイントに関するサービスを利用できるのは日本国内からに限るものとします。
                  </p>
                  <p>
                    (5)&emsp;特典を受け取る権利は、第三者に譲渡することはできません。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>3.&emsp;利用停止</h2>
                <div className={styles.detailText}>
                  <p>
                    ユーザーが、本規約を含む弊社が定めるその他の利用規約等に反する行為をしたと弊社が認めた場合には、弊社は、当該ユーザーに通知することなく、本サービスを含む提供中の全てのサービスの利用を停止することができるものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>4.&emsp;ユーザーの責任</h2>
                <div className={styles.detailText}>
                  <p>
                    (1)&emsp;ユーザーは、ユーザー自身の自己責任においてポイントを使用するものとし、ポイントについてなされた一切の行為およびその結果について一切の責任を負います。
                  </p>
                  <p>
                    (2)&emsp;ユーザーが未成年の場合は、保護者または親権者が同意の上、ポイントを取得・使用するものとします。
                  </p>
                  <p>
                    (3)&emsp;弊社は、ユーザーに対して新サービスの告知、広告配信、サービス運営上の事務連絡、その他情報の提供を行います。ただし、ユーザーが情報の提供を希望しない旨を、事前または事後に弊社に通知した場合は、ポイントに関するサービスに必要な場合を除いて、情報の提供を行わないものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>5.&emsp;特典に関する権利</h2>
                <div className={styles.detailText}>
                  <p>
                    特典およびポイントに関して生ずる著作権等を含む一切の権利は、弊社もしくは特典の提供者または第三者に帰属します。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  6.&emsp;Fanstaポイントに関するサービスの変更等
                </h2>
                <div className={styles.detailText}>
                  <p>
                    弊社は、弊社の都合により、Fanstaポイントに関するサービスをいつでも任意の理由で追加、変更、中断、終了することができるものとします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>7.&emsp;禁止行為</h2>
                <div className={styles.detailText}>
                  <p>
                    ユーザーは、Fanstaポイントに関するサービスの利用にあたり、次に掲げる行為を行ってはならないものとします。
                  </p>
                  <p>
                    (1)&emsp;ポイントに関するサービスの内容を弊社に無断で転載・複製・修正・蓄積または転送する行為。
                  </p>
                  <p>
                    (2)&emsp;弊社、他のユーザーおよび第三者の権利を侵害するまたはそのおそれがあるような行為。
                  </p>
                  <p>
                    (3)&emsp;犯罪的行為、もしくは犯罪的行為に結びつく行為、または公序良俗に反する行為、もしくはそのおそれのある行為。
                  </p>
                  <p>
                    (4)&emsp;虚偽の情報を提供したり、不正な目的で利用したりする行為。
                  </p>
                  <p>
                    (5)&emsp;本規約または弊社が定めるその他の利用規約等に違反すると弊社が判断する行為。
                  </p>
                  <p>
                    (6)&emsp;ポイントに関するサービスの運営を妨げる行為、または誹謗する行為。
                  </p>
                  <p>
                    (7)&emsp;ユーザーが未成年の場合、保護者または親権者の同意を得ずにポイントを取得・使用する行為。
                  </p>
                  <p>(8)&emsp;その他、法令に違反するおそれのある行為。</p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>8.&emsp;責任の制限</h2>
                <div className={styles.detailText}>
                  <p>
                    ポイントに関するサービスの利用にあたり弊社の責に帰する事由によりユーザーが損害を被った場合には、弊社は、100円を上限として、当該損害を賠償するものとします。ただし、弊社の故意または重過失に基づく場合は、この限りではありません。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>9.&emsp;免責</h2>
                <div className={styles.detailText}>
                  <p>
                    (1)&emsp;弊社は、ポイントに関するサービスの内容の追加、変更、不具合およびサービスの中断、終了によって生じたいかなる損害についても、一切責任を負いません。アクセス過多、その他予期せぬ要因で表示速度の低下や障害等が生じた場合も同様とします。
                  </p>
                  <p>
                    (2)&emsp;弊社は、ポイントおよびポイントに関するサービスの合法性、道徳性、信頼性、正確性について責任を負いません。
                  </p>
                  <p>
                    (3)&emsp;弊社は、本規約または弊社が定めるその他の利用規約等に違反する行為またはそのおそれのある行為が行われたと信じるに足りる相当な理由があると判断した場合には、当該行為を行ったユーザーの利用停止処分等の弊社が必要と考える措置をとる場合がありますが、それによって生じたいかなる損害についても、一切の責任を負いません。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <h2 className={styles.detailTitle}>
                  10.&emsp;準拠法および管轄裁判所
                </h2>
                <div className={styles.detailText}>
                  <p>(1)&emsp;本規約の準拠法は、日本法とします。</p>
                  <p>
                    (2)&emsp;ポイントに関するサービスまたは本規約に関してユーザーとの間で疑義または争いが生じた場合には、誠意をもって協議することとしますが、それでもなお解決しない場合には、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
                  </p>
                </div>
              </li>
              <li className={styles.listItem}>
                <div className={styles.detailText}>
                  <p>
                    <strong>附則</strong>
                    &emsp;本規約は、{startsAtText}から施行します。
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </main>
      </div>
    </CommonLayout>
  );
};

export default PointTermsPage;
